import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@app-environment';
import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfigData } from '../interfaces/config-data.interface';
import { RootServicesModule } from './root-services.module';
import { ConfigDto } from '@scf-monorepo/backend-lib/dtos';
import { ConfigType } from '@scf-monorepo/interfaces';

@Injectable({
    providedIn: RootServicesModule
})
export class ConfigService {
    private http = inject(HttpClient);

    public getAdminConfigs(): Observable<ConfigData<any>[]> {
        const adminTypes = [ConfigType.Country, ConfigType.Company, ConfigType.OrgUnit];

        return forkJoin(
            adminTypes.map((type) => this.http.get<ConfigDto[]>(`${environment.gatewayAPI}/config/${type}`))
        ).pipe(
            map((configs: ConfigDto[][]) => configs.reduce((acc, config) => [...acc, ...config], [])),
            map((configs) =>
                configs.map((data) => ({ id: data.entityId, type: data.type as ConfigType, data: data.data }))
            )
        );
    }

    public getConfig<T>(type: string, entityId: string) {
        const params = new HttpParams().set('entityId', entityId);
        return this.http.get<ConfigData<T>[]>(`${environment.gatewayAPI}/config/${type}`, { params });
    }

    public addConfig<T>(request: ConfigData<T>): Observable<ConfigData<T>> {
        return this.http.put<ConfigData<T>>(`${environment.gatewayAPI}/config`, request);
    }

    public updateConfig<T>(request: ConfigData<T>): Observable<ConfigData<T>> {
        return this.http.put<ConfigData<T>>(`${environment.gatewayAPI}/config`, request);
    }

    public deleteConfig(type: string, entityId: string) {
        const encodedEntityId = encodeURIComponent(entityId);
        return this.http.delete<void>(`${environment.gatewayAPI}/config/${type}/${encodedEntityId}`);
    }
}
